import { apiRequestActions } from '@ackee/redux-utils';
import { fetchIncidentTypes } from './types';

export default apiRequestActions(fetchIncidentTypes, { isDetailRequest: true });
